import { render, staticRenderFns } from "./TraxUiTopBox.vue?vue&type=template&id=273db3af"
import script from "./TraxUiTopBox.vue?vue&type=script&lang=js"
export * from "./TraxUiTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports